import { useTranslate } from "@similarweb/i18n-provider";
import { Warning } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import { industryTransitionKeys } from "app/pages/sales-intelligence/modules/industry/utils/i18n";

import { StyledCrmEnrichmentJobIndustryMappingWarning } from "./styles";

export const CrmEnrichmentJobIndustryMappingWarning = () => {
    const { translate } = useTranslate();

    return (
        <Tooltip content={translate(industryTransitionKeys.crmEnrichmentJobIndustryMappingTooltip)}>
            <StyledCrmEnrichmentJobIndustryMappingWarning
                alignItems="center"
                data-automation="crm-enrichment-job-industry-mapping-warning"
            >
                <Warning
                    size="xs"
                    color={colorsPalettes.yellow["600"]}
                />
            </StyledCrmEnrichmentJobIndustryMappingWarning>
        </Tooltip>
    );
};
